export default __webpack_public_path__ + "static/media/acm-flat.2546deac.jpg";